import React from "react";
import { Navigate, Route } from "react-router-dom";

import { ApmRoutes } from "@elastic/apm-rum-react";

import { AdminAccessConfirm } from "pages/admin/account/AdminAccessConfirm";
import { AdminAccessRequest } from "pages/admin/account/AdminAccessRequest";
import { ConfirmSignin } from "pages/admin/account/ConfirmSignin";
import { Password } from "pages/admin/account/Password";
import { PasswordReset } from "pages/admin/account/PasswordReset";
// account
import { SignIn } from "pages/admin/account/SignIn";
// carbon programs
import { CarbonPrograms } from "pages/admin/carbonPrograms/CarbonPrograms";
import { ArticleAdd } from "pages/admin/content/ArticleAdd";
import { ArticleUpdate } from "pages/admin/content/ArticleUpdate";
// content
import { Content } from "pages/admin/content/Content";
import { CourseAdd } from "pages/admin/content/CourseAdd";
import { CourseUpdate } from "pages/admin/content/CourseUpdate";
import { NewsAdd } from "pages/admin/content/NewsAdd";
import { NewsUpdate } from "pages/admin/content/NewsUpdate";
import { PopupUpdate } from "pages/admin/content/PopupUpdate";
// dashboard
import { Dashboard } from "pages/admin/dashboard/Dashboard";
// experiments
import { Experiments } from "pages/admin/experiments/Experiments";
import { SoilAI } from "pages/admin/experiments/SoilAI";
import { Farm } from "pages/admin/farms/Farm";
// farms
import { Farms } from "pages/admin/farms/Farms";
import { ShapefileSettings } from "pages/admin/farms/ShapefileSettings";
import { UpdateShapefileSettings } from "pages/admin/farms/UpdateShapefileSettings";
import { CreditForcasts } from "pages/admin/partners/CreditForcasts";
import { CreditPurchaseUpdate } from "pages/admin/partners/CreditPurchaseUpdate";
import { PartnerAdd } from "pages/admin/partners/PartnerAdd";
import { PartnerUpdate } from "pages/admin/partners/PartnerUpdate";
// partners
import { Partners } from "pages/admin/partners/Partners";
// farms
import { Payments } from "pages/admin/payments/Payments";
// funding
import { FundingAdd } from "pages/admin/programs/FundingAdd";
import { FundingUpdate } from "pages/admin/programs/FundingUpdate";
import { MethodAdd } from "pages/admin/programs/MethodAdd";
import { MethodUpdate } from "pages/admin/programs/MethodUpdate";
import { ModuleUpdate } from "pages/admin/programs/ModuleUpdate";
import { ModulesConfiguration } from "pages/admin/programs/ModulesConfiguration";
// programs
import { Programs } from "pages/admin/programs/Programs";
// redzones
import { Redzones } from "pages/admin/redzones/Redzones";
import { AdminUserAdd } from "pages/admin/settings/AdminUserAdd";
import { AdminUserUpdate } from "pages/admin/settings/AdminUserUpdate";
// admin
import { Settings } from "pages/admin/settings/Settings";
// notifications
import { NotificationAdd } from "pages/admin/users/NotificationAdd";
import { NotificationUpdate } from "pages/admin/users/NotificationUpdate";
import { User } from "pages/admin/users/User";
// users
import { Users } from "pages/admin/users/Users";
// verifications
import { CsvUpload as VerificationsCsvUpload } from "pages/admin/verifications/CsvUpload";
import { Farm as VerificationsFarm } from "pages/admin/verifications/Farm";
import { FarmList } from "pages/admin/verifications/FarmList";
import { NdviScores } from "pages/admin/verifications/NdviScores";
import { QuickFieldAccess } from "pages/admin/verifications/QuickFieldAccess";
import { VerificationsTaskList } from "pages/admin/verifications/VerificationsTaskList";
import { FootprintEditDetailsPage } from "pages/admin/verifications/components/footprinting/FootprintEditDetailsPage";
// misc
import ErrorPage from "pages/app/404";

export const AdminRoutes = () => {
  const routeList = (
    <ApmRoutes>
      {/* account */}
      <Route path="/" exact element={<Navigate replace to="/sign-in" />} />
      <Route path="/sign-in" exact element={<SignIn />} />
      <Route path="/confirm-sign-in/:userId/:token" exact element={<ConfirmSignin />} />
      <Route path="/password" exact element={<Password />} />
      <Route path="/password-reset/:token" exact element={<PasswordReset />} />
      <Route path="/admin-request" exact element={<AdminAccessRequest />} />
      <Route path="/admin-confirm/:id" exact element={<AdminAccessConfirm />} />

      {/* dashboard */}
      <Route path="/dashboard" exact element={<Dashboard />} />

      {/* content */}
      <Route path="/content/:section?" exact element={<Content />} />
      <Route path="/article/add" exact element={<ArticleAdd />} />
      <Route path="/article/update/:id" exact element={<ArticleUpdate />} />
      <Route path="/news/add" exact element={<NewsAdd />} />
      <Route path="/news/update/:id" exact element={<NewsUpdate />} />
      <Route path="/popup/update/:id" exact element={<PopupUpdate />} />
      <Route path="/course/add" exact element={<CourseAdd />} />
      <Route path="/course/update/:id" exact element={<CourseUpdate />} />
      {/* <Route path="/course/:id/chapters" exact element={<Admin />} /> */}

      {/* programs */}
      <Route path="/programs/modules/configure" exact element={<ModulesConfiguration />} />
      <Route path="/programs/:section?" exact element={<Programs />} />
      <Route path="/method/add" exact element={<MethodAdd />} />
      <Route path="/method/update/:id" exact element={<MethodUpdate />} />
      {/* <Route path="/module/:section?" exact element={<Admin />} /> */}
      <Route path="/module/update/:id" exact element={<ModuleUpdate />} />

      {/* carbon programs */}
      <Route path="/carbon-programs/:section?" exact element={<CarbonPrograms />} />

      {/* funding */}
      <Route path="/funding/add" exact element={<FundingAdd />} />
      <Route path="/funding/update/:id" exact element={<FundingUpdate />} />

      {/* users */}
      <Route path="/user/:id" exact element={<User />} />
      <Route path="/users/:section?" exact element={<Users />} />

      {/* notifications */}
      <Route path="/notification/add" exact element={<NotificationAdd />} />
      <Route path="/notification/update/:id" exact element={<NotificationUpdate />} />

      {/* farms */}
      <Route path="/farms/:section?" exact element={<Farms />} />
      <Route path="/farm/:id" exact element={<Farm />} />
      <Route path="/shapefile/updates/:id" exact element={<UpdateShapefileSettings />} />
      <Route path="/shapefile/updates" exact element={<ShapefileSettings />} />

      {/* payments */}
      <Route path="/payments/:section?" exact element={<Payments />} />

      {/* redzones */}
      <Route path="/redzones/:section?" exact element={<Redzones />} />

      {/* admin */}
      <Route path="/settings/:section?" exact element={<Settings />} />
      <Route path="/admin-user/add" exact element={<AdminUserAdd />} />
      <Route path="/admin-user/update/:id" exact element={<AdminUserUpdate />} />

      {/* experiments */}
      <Route path="/soilplus/:section?" exact element={<Experiments />} />
      <Route path="/soilai/:section?" exact element={<SoilAI />} />

      {/* partners */}
      <Route path="/partners/:section?" exact element={<Partners />} />
      <Route path="/partners/add" exact element={<PartnerAdd />} />
      <Route path="/partners/update/:id" exact element={<PartnerUpdate />} />
      <Route path="/partners/credit-purchases/:id/update" exact element={<CreditPurchaseUpdate />} />
      <Route path="/partners/predictions/forecasts" exact element={<CreditForcasts />} />

      {/* verifications */}
      <Route path="/verifications/farms/:farmId/:section?" exact element={<VerificationsFarm />} />
      <Route path="/verifications/farms/:farmId/footprinting/:footprintType/:footprintPrimaryDataId" exact element={<FootprintEditDetailsPage />} />
      <Route path="/verifications/farms" exact element={<FarmList />} />
      <Route path="/verifications/tasks" exact element={<VerificationsTaskList />} />
      <Route path="/verifications/csv-upload" exact element={<VerificationsCsvUpload />} />
      <Route path="/verifications/quick-field-access" exact element={<QuickFieldAccess />} />
      <Route path="/verifications/ndvi-scores" exact element={<NdviScores />} />

      {/* else */}
      <Route path="*" exact element={<ErrorPage />} />
    </ApmRoutes>
  );

  return routeList;
};
